import { CSSProperties } from 'react';
import styled from '@emotion/styled';

export default styled.img<{ filter: CSSProperties['filter'] }>((props) => ({
  filter: props.filter,
}));
